import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GoNavigationComponent } from '../shared/components/go-navigation/go-navigation.component';
import { ContactConstants } from '../../../../core/constants/contact-constants';
import { ExternalLinks } from '../../../../core/constants/external-links';

@Component({
    selector: 'app-go-about',
    templateUrl: './go-about.component.html',
    styleUrls: ['./go-about.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GoNavigationComponent],
})
export class GoAboutComponent {
    phoneNumber = ContactConstants.phoneNumber;
    email = ContactConstants.email;
    cevoUrl = ExternalLinks.enterpriseWireless.cevoUrl;
}
